import { computed } from 'vue'
import { useRoute } from 'vue-router'

export function usePdfQuery() {
  const route = useRoute()
  const shouldGenerate = computed(() => {
    return route.query.generatePdf === '1' || route.query.generatePdf === 'true'
  })
  const pdfQueryParams = computed(() => {
    const pdfName = route.query.pdfName
    const pdfPageSlug = route.query.pdfPageSlug

    return {
      pdfName,
      pdfPageSlug,
    }
  })
  return {
    shouldGenerate,
    pdfQueryParams,
  }
}
